import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { useUpdateUser } from '@modules/common/hooks/useUpdateUser';
import { useUserManagementStore } from '@modules/users/store/hooks';
import { UserManagementActionType } from '@modules/users/store/userManagementActionType';
import { UserRowRoleType } from '@modules/users/store/types';
import { getUserTypeFromUserRowRole } from '@modules/users/utils';
import { UUID } from 'v2/core/entities/uuid';

export const useUpdateUserType = () => {
  const { showSuccessNotification, showErrorNotification } =
    useNotificationContext();

  const dispatch = useUserManagementStore(({ dispatch }) => dispatch);

  const { updateUser, loading } = useUpdateUser({
    shouldShowErrorToast: false,
  });

  const updateUserType = async (
    id: UUID,
    updatedRole: UserRowRoleType.Admin | UserRowRoleType.Member,
    email: string,
  ) => {
    try {
      await updateUser({
        type: getUserTypeFromUserRowRole(updatedRole),
        id,
      });
      dispatch({
        type: UserManagementActionType.UPDATE_USER,
        payload: {
          id,
          user: {
            role: updatedRole,
          },
        },
      });
      showSuccessNotification({
        contentComponent: `Converted ${email} to ${updatedRole} role.`,
        props: {},
      });
    } catch {
      showErrorNotification({
        contentComponent: `Failed to convert ${email} to ${updatedRole} role.`,
        props: {},
      });
    }
  };

  return { updateUserType, isLoading: loading };
};
